






























































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { toStyleVal, isNumeric } from '@/utils';

interface SelectItem {
  text: string;
  value: string;
}

@Component
export default class AxSelectBox extends Vue {
  select = {
    text: '',
    value: ''
  };

  @Prop({ type: Array, default: () => [] })
  items!: SelectItem[];

  @Prop({ type: String, default: '175px' })
  width!: string;

  @Prop({ type: String, default: '32px' })
  height!: string;

  @Prop({ type: Boolean, default: false })
  lighten!: boolean;

  @Prop({ type: Boolean, default: false })
  filled!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  //font 고정 확인 해봐야함.
  @Prop({ type: String, default: '15px' })
  fontSize!: string;

  @Prop({ type: [String, Number], default: '' })
  value!: string | number;

  @Emit()
  change(idx: number) {
    return idx;
  }

  created() {
    const item = this.items?.find(x => x.value === this.value);

    if (item) {
      this.select.text = item.text;
      this.select.value = item.value;
    }
  }

  get styleVal() {
    const width = isNumeric(this.width) ? this.width + 'px' : this.width;
    const height = isNumeric(this.height) ? this.height + 'px' : this.height;

    return toStyleVal([
      ['width', width],
      ['height', height],
      ['fontSize', this.fontSize]
    ]);
  }
}
